<template>
  <div class="map-wrapper">
    <div id="echartsMap"></div>
  </div>
</template>
<script>

import '../../../utils/china.js'
export default {
  data() {
    return {
      geoCoordMap: {
        // 国内
        台湾: [121.509062, 25.044332],
        河北: [114.502461, 38.045474],
        山西: [112.549248, 37.857014],
        内蒙古: [111.670801, 40.818311],
        辽宁: [123.429096, 41.796767],
        吉林: [125.3245, 43.886841],
        黑龙江: [126.642464, 45.756967],
        浙江: [120.153576, 30.287459],
        安徽: [117.283042, 31.86119],
        福建: [119.306239, 26.075302],
        江苏: [118.767413, 32.041544],
        江西: [115.892151, 28.676493],
        湖北: [114.298572, 30.584355],
        山东: [117.000923, 36.675807],
        河南: [113.665412, 34.757975],
        湖南: [112.982279, 28.19409],
        广东: [113.280637, 23.125178],
        广西: [108.320004, 22.82402],
        海南: [110.33119, 20.031971],
        四川: [104.065735, 30.659462],
        贵州: [106.713478, 26.578343],
        云南: [102.712251, 25.040609],
        西藏: [91.132212, 29.660361],
        陕西: [108.948024, 34.263161],
        甘肃: [103.823557, 36.058039],
        青海: [101.778916, 36.623178],
        宁夏: [106.278179, 38.46637],
        北京: [116.405285, 39.904989],
        天津: [117.190182, 39.125596],
        上海: [121.472644, 31.231706],
        重庆: [106.504962, 29.533155],
        香港: [114.173355, 22.320048],
        澳门: [113.54909, 22.198951],
        新疆: [87.617733, 43.792818],
      },
      GNData: [
        [
          {
            name: "湖北",
          },
          {
            name: "台湾",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "河北",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "山西",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "内蒙古",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "辽宁",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "吉林",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "黑龙江",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "江苏",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "浙江",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "安徽",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "福建",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "江西",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "山东",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "河南",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "湖南",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "广东",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "广西",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "海南",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "四川",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "贵州",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "云南",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "西藏",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "陕西",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "甘肃",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "青海",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "宁夏",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "新疆",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "北京",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "天津",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "上海",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "重庆",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "香港",
            value: 30,
          },
        ],
        [
          {
            name: "湖北",
          },
          {
            name: "澳门",
            value: 30,
          },
        ],
      ],
      series: [], // 用来存储地图数据
      color: ["#9ae5fc", "#dcbf71"], // 自定义图中要用到的颜色
    };
  },
  mounted() {
    let chart = this.$echarts.init(document.getElementById("echartsMap"));
    // 小飞机的图标，可以用其他图形替换
    var planePath =
      "path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z";
    [["湖北", this.GNData]].forEach((item, i) => {
      this.series.push(
        {
          // 白色航线特效图
          type: "lines",
          zlevel: 1, // 用于分层，z-index的效果
          effect: {
            show: true, // 动效是否显示
            period: 6, // 特效动画时间
            trailLength: 0.7, // 特效尾迹的长度
            color: "#fff", // 特效颜色
            symbolSize: 3, // 特效大小
          },
          lineStyle: {
            normal: {
              // 正常情况下的线条样式
              color: this.color[0],
              width: 0, // 因为是叠加效果，要是有宽度，线条会变粗，白色航线特效不明显
              curveness: -0.2, // 线条曲度
            },
          },
          data: this.convertData(item[1]), // 特效的起始、终点位置
        },
        {
          // 小飞机航线效果
          type: "lines",
          zlevel: 2,
          //symbol: ['none', 'arrow'],   // 用于设置箭头
          symbolSize: 10,
          effect: {
            show: true,
            period: 6,
            trailLength: 0,
            // symbol: planePath, // 特效形状，可以用其他svg pathdata路径代替
            symbolSize: 5,
          },
          lineStyle: {
            normal: {
              color: this.color[0],
              width: 1,
              opacity: 0.6,
              curveness: -0.2,
            },
          },
          data: this.convertData(item[1]), // 特效的起始、终点位置，一个二维数组，相当于coords: convertData(item[1])
        },
        
        {
          // 散点效果
          type: "effectScatter",
          coordinateSystem: "geo", // 表示使用的坐标系为地理坐标系
          zlevel: 3,
          rippleEffect: {
            brushType: "stroke", // 波纹绘制效果
          },
          label: {
            normal: {
              // 默认的文本标签显示样式
              show: true,
              position: "left", // 标签显示的位置
              formatter: "{b}", // 标签内容格式器
            },
          },
          itemStyle: {
            normal: {
              color: this.color[0],
            },
          },
          data: item[1].map((dataItem) => {
            return {
              name: dataItem[1].name,
              value: this.geoCoordMap[dataItem[1].name], // 起点的位置
              symbolSize: dataItem[1].value / 4, // 散点的大小，通过之前设置的权重来计算，val的值来自data返回的value
            };
          }),
        }
      );
    });

    // 显示终点位置,类似于上面最后一个效果，放在外面写，是为了防止被循环执行多次
    this.series.push({
      type: "effectScatter",
      coordinateSystem: "geo",
      zlevel: 3,
      rippleEffect: {
        brushType: "stroke",
      },
      label: {
        normal: {
          show: true,
          position: "left",
          formatter: "{b}",
        },
      },
      symbolSize: function (val) {
        return val[2] / 8;
      },
      itemStyle: {
        normal: {
          color: this.color[1],
        },
      },
      data: [
        {
          name: "湖北",
          value: [114.298572, 30.584355, 30],
          label: {
            normal: {
              position: "right",
            },
          },
        },
      ],
    });

    // 最后初始化世界地图中的相关数据
    chart.setOption({
      backgroundColor: "#101724",
      title: {
        //text: '中国国际贸易促进委员会',
        //subtext: '国别资讯',
        textStyle: {
          color: "#fff",
          fontSize: 20,
        },
      },
      geo: {
        map: 'china', // 与引用进来的地图js名字一致
        roam: false, // 禁止缩放平移
        zoom:1.24,
        itemStyle: {
          // 每个区域的样式
          normal: {
            areaColor: "#7d7d7d",
          },
          emphasis: {
            areaColor: "#2a333d",
          },
        },
        regions: [
          {
            // 选中的区域
            name: "wuhan",
            selected: false,
            itemStyle: {
              // 高亮时候的样式
              emphasis: {
                areaColor: "#7d7d7d",
              },
            },
            label: {
              // 高亮的时候不显示标签
              emphasis: {
                show: false,
              },
            },
          },
        ],
      },
      series: this.series, // 将之前处理的数据放到这里
      textStyle: {
        fontSize: 12,
      },
    });
  },
  methods: {
    // 获取地图中起点和终点的坐标，以数组形式保存下来
    convertData (data) {
      let res = [];
      for (let i = 0; i < data.length; i++) {
        let dataItem = data[i];
        let fromCoord = this.geoCoordMap[dataItem[0].name];
        let toCoord = this.geoCoordMap[dataItem[1].name];
        if (fromCoord && toCoord) {
          res.push([
            {
              coord: fromCoord, // 起点坐标
            },
            {
              coord: toCoord, // 终点坐标
            },
          ]);
        }
      }
      return res;
    }
  }
};
</script>
<style scoped>

#echartsMap {
  width: 700px;
  height: 400px;
  /* margin-top: -100px; */
}

.map-wrapper {
  background-color: #101724;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>